import { Ilanguages } from "../types";

const english: Ilanguages = {
  homeMessage1:
    "You have been directed to this page to make a payment on a Pennsylvania Department of Transportation (PennDOT) Invoice.",
  homeMessage2:
    "Payments are accepted for the following invoices only: Highway Occupancy Permits, Bridge Occupancy Licenses, Accident Damages, Right-to-Know Law, Junkyard Licenses, HBMS, APRAS Special Hauling Permits, Bonded Highway, and Marcellus Shale.",
  homeMessage3:
    "Please fill out the items below and select submit to be taken to the checkout page.  Payments are to be made in full unless a previous agreement was reached with PennDOT. Once completed you will be given the option to print the receipt, have the receipt e-mailed to you, or close out of the checkout page.",
  homeMessage4:
    "If you have questions about requirements of this page, please call 717-346-9901 option 1.",
  homeMessage5: "Thank You",
  continue: "Continue",
  back: "Back",
  welcome: "Welcome",
  billingInformation: "Billing",
  invoices: "Invoice",
  review: "Review",
  firstName: "Name As It Appears On Credit Card",
  lastName: "Last Name",
  address: "Address",
  city: "City",
  state: "State/Province",
  zipCode: "Zip/Postal Code",
  phone: "Phone Number",
  email: "Email",
  emailVerify: "Email Verify",
  sapDocumentNumber: "SAP Document Number",
  refNumber: "Invoice/Reference Number",
  refSapNumber: "Invoice/Reference/SAP Number",
  searchHelp: "Search Help",
  amountPaying: "Amount Paying",
  totalAmountDue: "Total Amount Due",
  addInvoice: "Add Invoice",
  enterCreditCard: "Enter Credit Card",
  invoiceMessage1:
    "Please search for an invoice by a SAP document number or Reference number",
  tranMessage1:
    "After the customer completes the payment on Payeez the they will be returned to the Pay PennDOT site. The below text will be displayed when this occurs.",
  tranMessage2:
    "Thank you for your payment.  If a problem is found with your payment, you will be contacted by the next business day.  Please allow 3-5 business days for your invoice to be cleared.",
  tranMessage3: "If you have any questions, please call 717-346-9901 Option 1.",
  tranMessage4: "Thank you",
  tranMessage5: "PennDOT Bureau of Fiscal Management",
  underPaymentPreApproved:
    "Anything less than the full amount must be pre-approved"
};

export default english;
